import { Flex, Progress, Text } from 'components'
import { useSessionImport } from './SessionImportProvider'

export default function SessionImportReview() {
  const { appTitle, appType, spreadsheet, selectedTab, data, progress } = useSessionImport()

  const fileName = spreadsheet?.file.name

  return (
    <Flex px={6} flexDirection="column" gap={4}>
      {appType === 'custom' ? (
        <ReviewItem label="App Name" value={appTitle} />
      ) : (
        <Text textStyle="bodyMedium">Explorer App</Text>
      )}
      <ReviewItem label="File Name" value={fileName || ''} />
      <ReviewItem label="Tab Name" value={selectedTab} />
      <ReviewItem label="Row Count" value={`${data?.length.toString() || '0'} rows`} />
      <Progress
        background={progress ? 'gray.300' : 'transparent'}
        borderRadius="999px"
        colorPalette="secondary"
        css={{ '& > div': { transition: 'width 100ms ease' } }}
        value={progress}
      />
    </Flex>
  )
}

function ReviewItem({ label, value }: { label: string; value: string }) {
  return (
    <Flex flexDirection="column" gap={2}>
      <Text textStyle="bodySmall" color="gray.500">
        {label}
      </Text>
      <Text textStyle="bodyMedium">{value}</Text>
    </Flex>
  )
}
